import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const SERVER_URL = process.env.REACT_APP_SERVER_URL;
        const response = await axios.get(`${SERVER_URL}/api/languages/`);
        setLanguages(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchLanguages();
  }, []);

  return (
    <LanguageContext.Provider value={{ languages, loading, error }}>
      {children}
    </LanguageContext.Provider>
  );
};
